import React, { useState } from "react";
import styles from "./styles/CalendarOutline.module.css";
import { Button, Modal, Typography, theme, Grid } from "antd";
import { PLATFORM_IMG_MAPPING } from "./SocialMediaCards";
import { ArrowRightOutlined, EditOutlined } from "@ant-design/icons";
import { useBusiness } from "../_actions/finance";
import log from "cslog";

export default function CalendarOutlineGenerator({
    open,
    setOpen,
    data,
    user_inputs = {},
}) {
    const { Title } = Typography;
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    // Function to parse the data and create outline sections

    const mutationBusiness = useBusiness(
        "gen/generate_content_calendar",
        (response) => {
            const apiData = response.data;
            console.log("Content generation successful:", apiData);
            setOpen(false);
        },
        () => {
            // done
        },
        ["items", "qdb_calendar_entries"]
    );

    return (
        <Modal
            open={open}
            onCancel={() => setOpen(false)}
            width={isMobile ? "100%" : 1000}
            title={"Content Calendar Outline"}
            okText="Generate Calendar"
            okButtonProps={{
                icon: <ArrowRightOutlined />,
                iconPosition: "end",
                loading: mutationBusiness.isLoading,
                size: isMobile ? "large" : "middle",
            }}
            cancelButtonProps={{ size: isMobile ? "large" : "middle" }}
            cancelText="Back"
            onOk={() => {
                const out = {
                    ...user_inputs,
                    outline: data,
                };
                log.d(out, "out");
                mutationBusiness.mutate(out);
            }}
            maskClosable={false}
        >
            <div className={styles.new_outline_box_list}>
                {data &&
                    Object.values(data).map((month_data) => {
                        return Object.values(month_data).map((week_data) => {
                            return Object.keys(week_data).map((dt) => {
                                if (!dt.startsWith("20")) return null;
                                return (
                                    <OutlineSection
                                        key={dt}
                                        data={week_data[dt]}
                                    />
                                );
                            });
                        });
                    })}
            </div>

            {/* Bottom Section */}
        </Modal>
    );
}

function OutlineSection({ data }) {
    const { token } = theme.useToken();

    const BG_COLOR_MAPPING = {
        "Value Added": token.colorSuccessBg,
        "Engagement Driven": token.colorInfoBg,
        Promotional: token.colorErrorBg,
    };

    const COLOR_MAPPING = {
        "Value Added": token.colorSuccess,
        "Engagement Driven": token.colorInfo,
        Promotional: token.colorError,
    };
    return (
        <div
            className={styles.new_outline_box}
            style={
                {
                    // backgroundColor: BG_COLOR_MAPPING[data.broad_category],
                }
            }
        >
            <h4>{data.name}</h4>
            {/* <div
                className={styles.broad_category}
                style={{ color: COLOR_MAPPING[data.broad_category] }}
            >
                {data.broad_category}
            </div> */}
            <div className={styles.platform_content}>
                <div
                    style={{
                        textTransform: "uppercase",
                        backgroundColor: COLOR_MAPPING[data.broad_category],
                        color: "white",
                        padding: "3px 9px",
                        borderRadius: "12px",
                        lineHeight: 1,
                        fontSize: ".9em",
                        fontWeight: "bold",
                    }}
                >
                    {data.broad_category}
                </div>
                <div className={styles.chip_list_wrapper}>
                    {data?.data?.map((item) => (
                        <div className={styles.chip_wrapper}>
                            {/* <pre>{item.content_type?.[0]}</pre> */}
                            {item.content_type?.map((ct) => (
                                <img
                                    src={`/images_rte/icons/${
                                        PLATFORM_IMG_MAPPING[ct] || ct
                                    }.png`}
                                    alt="medium"
                                    className={styles.chip_platform_icon}
                                />
                            ))}
                            {/* <img
                                src={`/images_rte/icons/${
                                    PLATFORM_IMG_MAPPING[
                                        item.content_type?.[0]
                                    ] || item.platform
                                }.png`}
                                alt="medium"
                                className={styles.chip_platform_icon}
                            /> */}
                            <div className={styles.chip_category}>
                                {item.category}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* <div className={styles.edit_btn}>
                <EditOutlined style={{ cursor: "pointer" }} />
            </div> */}
        </div>
    );
}
